import { memo } from 'react';
import AvatarImage from '../common/AvatarImage';

interface User {
  id: string;
  username: string;
  status: 'online' | 'away' | 'offline' | 'idle' | 'dnd';
  lastSeenAt?: string | number;
  avatarUrl?: string | null;
}

interface OnlineUserItemProps {
  user: User;
  onClick?: () => void;
}

const OnlineUserItem = memo(function OnlineUserItem({ user, onClick }: OnlineUserItemProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'online':
        return 'bg-green-500';
      case 'away':
      case 'idle':
        return 'bg-yellow-500';
      case 'dnd':
        return 'bg-brand-error';
      case 'offline':
        return 'bg-brand-outline-variant';
      default:
        return 'bg-brand-outline-variant';
    }
  };

  return (
    <div
      onClick={onClick}
      className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-white/10 active:scale-[0.98] transition-all cursor-pointer group"
    >
      <div className="relative flex-shrink-0">
        <div className="w-9 h-9 rounded-full bg-primary-600 flex items-center justify-center overflow-hidden shadow-sm group-hover:scale-105 transition-transform">
          <AvatarImage
            src={user.avatarUrl || undefined}
            alt={user.username}
            fallback={
              <span className="text-brand-on-primary font-bold text-xs">
                {user.username?.[0]?.toUpperCase() || 'U'}
              </span>
            }
          />
        </div>
        <div
          className={`absolute bottom-0 right-0 w-3.5 h-3.5 ${getStatusColor(user.status)} rounded-full border-2 border-brand-background dark:border-[#1e1b4b] shadow-sm`}
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-brand-on-background dark:text-[#e0e7ff] truncate group-hover:text-white transition-colors">
          {user.username}
        </p>
        <p className="text-xs text-brand-outline dark:text-[#c4b5fd]">
          {user.status === 'online'
            ? 'Online'
            : user.status === 'idle' || user.status === 'away'
              ? 'Idle'
              : user.status === 'dnd'
                ? 'Do Not Disturb'
                : 'Offline'}
        </p>
      </div>
    </div>
  );
});

export default OnlineUserItem;
